/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ProfileService } from './model/profileService';

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiProviderProfileCreateServicesList = (signal?: AbortSignal) => {
  return HTTP<ProfileService[]>({
    url: `/api/v7/provider-profile/services/list/`,
    method: 'GET',
    signal,
  });
};

export const getApiProviderProfileCreateServicesListQueryKey = () => {
  return [`/api/v7/provider-profile/services/list/`] as const;
};

export const getApiProviderProfileCreateServicesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderProfileCreateServicesListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>
  > = ({ signal }) => apiProviderProfileCreateServicesList(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiProviderProfileCreateServicesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>
>;
export type ApiProviderProfileCreateServicesListQueryError = ErrorType<unknown>;

export function useApiProviderProfileCreateServicesList<
  TData = Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiProviderProfileCreateServicesListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
